// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserDeleteOutlinedSvg from "@ant-design/icons-svg/es/asn/UserDeleteOutlined";
import AntdIcon from '../components/AntdIcon';

var UserDeleteOutlined = function UserDeleteOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserDeleteOutlinedSvg
  }));
};

UserDeleteOutlined.displayName = 'UserDeleteOutlined';
export default React.forwardRef(UserDeleteOutlined);